import { render, staticRenderFns } from "./BaseBFormModal.vue?vue&type=template&id=961061a8&scoped=true"
import script from "./BaseBFormModal.vue?vue&type=script&lang=js"
export * from "./BaseBFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961061a8",
  null
  
)

export default component.exports